module.exports = __webpack_public_path__ + "static/media/Museumskatalog_Pionierfrauen.eac8d755.pdf";